import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { getRequest } from "../../apis/ApiInstence";

const ProductSalesChart = () => {
  const [categories, setCategories] = useState([]);
  const [data, setData] = useState([]);

  useEffect(() => {
    getRequest("dashboard/product-sales").then(res => {
      const result = res.data.data;
  
      setCategories(result.map(i => i['category.name']));
      setData(result.map(i => Number(i.qty)));
    });
  }, []);

  const options = {
    chart: { type: "column" },
    title: { text: "Most Required Services / Products" },
    xAxis: { categories },
    yAxis: {
      min: 0,
      title: { text: "Total Orders" }
    },
    series: [
      {
        name: "Orders",
        data
      }
    ]
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default ProductSalesChart